import React, { useEffect, useReducer } from "react";

import './App.css';
import GeneralContext from './context/GeneralContext';
import * as GeneralReducer from './store/reducers/generalReducer';
import * as GeneralActions from './store/actions/generalActions';
import Routes from "./utils/routes";
import { getUserAuthenticated } from "./utils/auth/Auth-utils";

const App = () => {
  const [state, dispatch] = useReducer(GeneralReducer.GeneralReducer, GeneralReducer.initialState);
  
  useEffect(() => {
    const user = getUserAuthenticated();
    if(user) dispatch(GeneralActions.setLogin(user));
  }, [ ])

  return (
    <GeneralContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <Routes />
    </GeneralContext.Provider>
  );
}

export default App;